import axios from 'axios';
import  {AUTH_TOKEN_KEY } from '../constants';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Request interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (token) {
    console.log("Setting token on api request: " + token);
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Response interceptor
api.interceptors.response.use((response) => {
  return response;
}, (error) => {
  if (error.response && error.response.status === 401) {
    // Handle unauthorized error (e.g., redirect to login)
    localStorage.removeItem(AUTH_TOKEN_KEY);
    //window.location.href = '/halo/login';
  }
  return Promise.reject(error);
});

export default api;